import { render, staticRenderFns } from "./GAndACategoriesDetail.vue?vue&type=template&id=02437110&"
import script from "./GAndACategoriesDetail.vue?vue&type=script&lang=js&"
export * from "./GAndACategoriesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports